import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import { DateFilterCellComponent } from '@progress/kendo-angular-grid';
import { DatePipe } from '@angular/common';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  getScreenVal: any;
  userInfo: any;
  tokenArray: any = [];
  endPoint: any;
  header: any
  constructor(private http: HttpClient, public spinner: NgxSpinnerService, public datePipe: DatePipe) {
    this.endPoint = environment.endpoint;
  }

  getHeaders(url, iudToken) {
    const token = localStorage.getItem(`token`);
    let filterSess: any;
    let gotToken: any;
    let spliceUrl;
    let getUrl = url?.includes("?");
    if (getUrl) {
      const firstUrl = url.split("?");
      spliceUrl = firstUrl[0];
    } else {
      spliceUrl = url
    }
    let headerValue = {};
    if (url == '/getLogin?') {
      headerValue = {
        '_url': '/getLogin',
        'Content-Type': 'application/json',
        'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
        'X-Tenant-Identifier': 'dynamic_lokos',
        'Authorization': token ? 'Bearer ' + token : '',
        'Cache-Control': 'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
        'langCode' : 'en_US'
        // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
        // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
        // "X-Content-Type-Options": "nosniff",
        // "X-Frame-Options": "DENY",
        // "X-XSS-Protection": "1; mode=block",
        // 'userCode': this.userInfo ? this.userInfo.loginId : '',
        // 'roleCode': (this.userInfo && this.userInfo.userRoles) ? this.userInfo.userRoles[0].applicationRole.roleName : '',
        // 'blockCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].blockData.blockCode.toString() : '',
      }
    } else {
      let spliceUrl;
      let getUrl = url?.includes("?");
      if (getUrl) {
        const firstUrl = url.split("?");
        //console.log(`firstUrl`, firstUrl)
        spliceUrl = firstUrl[0];
      } else {
        spliceUrl = url
      }
      //console.log(`spliceUrl`, spliceUrl)
      this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
      if (this.userInfo) {
      // const lang = JSON.parse(localStorage.getItem('selectedLang'))?.lang_code
        headerValue = {
          'Content-Type': 'application/json',
          'Content-Security-Policy': "frame-ancestors 'self'",
          'X-Tenant-Identifier': 'dynamic_lokos',
          'Authorization': token ? 'Bearer ' + token : '',
          'Cache-Control': 'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0',
          // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
          "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
           "X-XSS-Protection": "1; mode=block",
          '_url': spliceUrl,
          '_user_token': iudToken ? iudToken : '',
          '_user_code': this.userInfo ? this.userInfo.loginId : '',
          'userCode': this.userInfo ? this.userInfo.loginId : '',
          'roleCode': (this.userInfo && this.userInfo.userRoles) ? this.userInfo.userRoles[0].applicationRole.roleName : '',
          'blockCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].blockData.blockCode.toString() : '',
          'langCode' : 'en_US',
          'stateCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].stateData.stateCode.toString() : '',
          'stateId': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].stateData.stateId.toString() : '',
        }
      } else {
        headerValue = {
          'Content-Type': 'application/json',
          'Content-Security-Policy': "frame-ancestors 'self'",
          //'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
          'X-Tenant-Identifier': 'dynamic_lokos',
          'Authorization': token ? 'Bearer ' + token : '',
          'Cache-Control': 'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0',
          '_url': spliceUrl,
          // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
          "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "X-XSS-Protection": "1; mode=block",
          'userCode': '',
          '_user_token': iudToken ? iudToken : '',
          '_user_code': this.userInfo ? this.userInfo.loginId : '',
          'roleCode': (this.userInfo && this.userInfo.userRoles) ? this.userInfo.userRoles[0].applicationRole.roleName : '',
          'blockCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].blockData.blockCode.toString() : '',
          'langCode' : 'en_US',
          'stateCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].stateData.stateCode.toString() : '',
          'stateId': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].stateData.stateId.toString() : '',
        }
      }
    }
    return new HttpHeaders(headerValue);
  }

  withoutAuthToken() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      '_url': '/authenticate'
    });
  }

  getParams() {
    let obj
    this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
    if (this.userInfo) {
      return obj = {
        userCode: this.userInfo.loginId,
        roleCode: this.userInfo.userRoles[0].applicationRole.roleName,
        blockCode: this.userInfo.userRoleGeographies[0].blockData.blockCode
      }
    }
  }

  get(url1: string): Observable<any> {
    let url;
    let iudtoken;
    let getUrl = url1?.includes("@");
    if (getUrl) {
      const firstUrl = url1?.split("@");
      iudtoken = firstUrl[1];
      url = firstUrl[0]
    } else {
      url = url1
    }
    let token;
    token = localStorage.getItem(`token`);
    const lang: any = localStorage.getItem(`selectedLang`);
    let selLang = JSON.parse(lang);
    return this.http.get<any>(`${environment.endpoint}${url}${'&langCode='}${selLang ? selLang.lang_code : 'en_US'}`, { headers: this.getHeaders(url, iudtoken ) })
  }

  getWithoutLang(url1: string): Observable<any> {
    let token;
    let url;
    let iudtoken;
    token = localStorage.getItem(`token`);
    let getUrl = url1?.includes("@");
    if (getUrl) {
      const firstUrl = url1?.split("@");
      iudtoken = firstUrl[1];
      url = firstUrl[0];
    } else {
      url = url1;
    }
    // this.getUserToken(url1, token);
    return this.http.get<any>(`${environment.endpoint}${url}`, {headers: this.getHeaders(url, iudtoken) });
  }

  postWithoutEnvironment(url: string, data: any): Observable<any> {
    let token;
    if (localStorage.getItem(`token`)) {
      token = localStorage.getItem(`token`);
    }
    // this.getUserToken(url, token);
    return this.http.post<any>(`${url}`, JSON.stringify(data), { headers: this.getHeaders(url, token) });
  }

  post(url1: string, data: any): Observable<any> {
    let token;
    let url;
    let iudtoken;
    token = localStorage.getItem(`token`);
    let getUrl = url1?.includes("@");
    if (getUrl) {
      const firstUrl = url1?.split("@");
      iudtoken = firstUrl[1];
      url = firstUrl[0]
    } 
    const lang = JSON.parse(localStorage.getItem('selectedLang'))?.lang_code
    return this.http.post<any>(`${environment.endpoint}${url}${'&langCode='}${lang ? lang : 'en_US'}`, JSON.stringify(data), { headers: this.getHeaders(url, iudtoken) });
  }

  post_(url1: string, data: any): Observable<any> {
    let token;
    let url;
    let iudtoken;
    token = localStorage.getItem(`token`);
    let getUrl = url1?.includes("@");
    if (getUrl) {
      const firstUrl = url1?.split("@");
      iudtoken = firstUrl[1];
      url = firstUrl[0]
    } 
    // this.getUserToken(url, token);
    return this.http.post<any>(`${environment.endpoint}${url}`, JSON.stringify(data), { headers: this.getHeaders(url, iudtoken) });
  }

  // getScrwithOutLangeenData(ScreenCode: String): any {  
  //   const header = new HttpHeaders({ 'content-type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem(`token`) });          
  //   this.http.post(`/Getscreendata?screenCode=${ScreenCode}`, {}, {headers: header}).subscribe((res: any) => {
  //   return res;
  //   });
  // }

  withOutLang(url1: string, data: any): Observable<any> {
    this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
    let token;
    let url;
    let iudtoken;
    token = localStorage.getItem(`token`);
    let getUrl = url1?.includes("@");
    if (getUrl) {
      const firstUrl = url1?.split("@");
      iudtoken = firstUrl[1];
      url = firstUrl[0];
    } else {
      url = url1;
    }
    // this.getUserToken(url, token);
    // const header = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem(`token`), '_url': url, '_user_code': this.userInfo ? this.userInfo.loginId : '' , '_user_token': iudtoken})
    return this.http.post<any>(`${environment.endpoint}${url}`, data, { headers: this.withoutLangHeader(url, iudtoken) });
  }

  withOutLangWithContent(url: string, data: any): Observable<any> {
    let token;
    if (localStorage.getItem(`token`)) {
      token = localStorage.getItem(`token`);
    }
    // this.getUserToken(url, token);
    return this.http.post<any>(`${environment.endpoint}${url}`, data, { headers: this.getHeaders(url, token) });
  }

  getWithOutLang(url1: string): Observable<any> {
    let token;
    let url;
    let iudtoken;
    token = localStorage.getItem(`token`);
    let getUrl = url1?.includes("@");
    if (getUrl) {
      const firstUrl = url1?.split("@");
      iudtoken = firstUrl[1];
      url = firstUrl[0]
    } else {
      url = url1
    }
    if (localStorage.getItem(`token`)) {
      token = localStorage.getItem(`token`);
    }
    // this.getUserToken(url, token);
    return this.http.get<any>(`${environment.endpoint}${url}`, { headers: this.getHeaders(url, iudtoken) });
  }

  getLang(url: string): Observable<any> {
    let token;
    if (localStorage.getItem(`token`)) {
      token = localStorage.getItem(`token`);
    }
    // this.getUserToken(url, token);
    return this.http.get<any>(`${environment.endpoint}${url}`);
  }

  withoutEnviroment(url: string, data: any) {
    let token;
    if (localStorage.getItem(`token`)) {
      token = localStorage.getItem(`token`);
    }
    // this.getUserToken(url, token);
    return this.http.post<any>(`${environment.endpoint}${url}`, JSON.stringify(data), { headers: this.withoutAuthToken() });
  }

  getToken(url: string, data: any) {
    const header = new HttpHeaders({ 'content-type': 'application/json', '_url': '/authenticate' });
    return this.http.post<any>(`${environment.endpoint}${url}`, JSON.stringify(data), { headers: header });
  }

  getIPAddress() {
    return this.http.get("http://api.ipify.org/?format=json");
  }


  withoutLangHeader(url, iudToken){
    const token = localStorage.getItem(`token`);
    let headerValue = {};
    let spliceUrl;
    let getUrl = url?.includes("?");
    if (getUrl) {
      const firstUrl = url.split("?");
      spliceUrl = firstUrl[0];
    } else {
      spliceUrl = url
    }
    this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
    if (this.userInfo) {
      headerValue = {
       // 'Content-Type': 'application/json',
        'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
         'X-Tenant-Identifier': 'dynamic_lokos',
        'Authorization': token ? 'Bearer ' + token : '',
        // 'Cache-Control': 'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
        // 'Pragma': 'no-cache',
        // 'Expires': '0',
         "X-Frame-Options": "DENY",
        '_url': spliceUrl,
        '_user_token': iudToken ? iudToken : '',
        '_user_code': this.userInfo ? this.userInfo.loginId : '',
        'userCode': this.userInfo ? this.userInfo.loginId : '',
        'roleCode': (this.userInfo && this.userInfo.userRoles) ? this.userInfo.userRoles[0].applicationRole.roleName : '',
        'blockCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].blockData.blockCode.toString() : '',
        'stateCode': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].stateData.stateCode.toString() : '',
          'stateId': (this.userInfo && this.userInfo.userRoleGeographies) ? this.userInfo.userRoleGeographies[0].stateData.stateId.toString() : '',
      }
    } else {
      headerValue = {
        'Content-Type': 'application/json',
         'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
          'X-Tenant-Identifier': 'dynamic_lokos',
         'Authorization': token ? 'Bearer ' + token : '',
          "X-Frame-Options": "DENY",
         '_url': spliceUrl,
         '_user_token': iudToken ? iudToken : '',
       }
    }
    return new HttpHeaders(headerValue);
  }



  // Client url

  clientUrl(url: string, data: any) {
    return this.http.post<any>(`${url}`, JSON.stringify(data), { headers: this.header });
  }

  clientUrlGet(url: string) {
    return this.http.get<any>(`${url}`, { headers: this.heaserWithToken() })
  }

  heaserWithToken() {
    const token = localStorage.getItem(`accessToken`);
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-Identifier': 'dynamic_lokos',
      'Authorization': token,
      'role': '310',
      'User': "UP_BKSHG1"
    });
  }
  //VPRP Url

  vprpPost(url: string, data: any) {
    return this.http.post<any>(`${environment.vprp_endpoint}${url}`, JSON.stringify(data), { headers: this.getVPRPHeaders() });
  }

  vprpGet(url: string) {
    return this.http.get<any>(`${environment.vprp_endpoint}${url}`, { headers: this.getVPRPHeaders() })
  }

  vprpPut(url: string, data: any) {
    return this.http.put<any>(`${environment.vprp_endpoint}${url}`, JSON.stringify(data), { headers: this.getVPRPHeaders() });
  }

  vprpDelete(url: string) {
    return this.http.delete<any>(`${environment.vprp_endpoint}${url}`, { headers: this.getVPRPHeaders() });
  }

  getVPRPHeaders() {
    const vprptokend = localStorage.getItem(`vprptoken`);
    // const token = localStorage.getItem(`token`)
    // console.log(`vprptoken`, vprptokend, token);
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'channel': '1001',
      'Authorization': vprptokend ? `Bearer ${vprptokend}` : '',
      // 'Authorization': token ? `Bearer ${token}` : '',
    });
  }

  encrypt(word, dateTime?: any) {
    const keyBase64 = "o9szYIOq1rRMiouNhNvaq96lqUvCekxR";
    var key = CryptoJS.enc.Base64.parse(keyBase64);
    var srcs = CryptoJS.enc.Utf8.parse(word + "~" + dateTime);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  }

  loginEncrypt(word, token?: any, url?:any) {
    const keyBase64 = "o9szYIOq1rRMiouNhNvaq96lqUvCekxR";
    var key = CryptoJS.enc.Base64.parse(keyBase64);
    var srcs = CryptoJS.enc.Utf8.parse(word + "~" + token + "~" + url);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
  }

  getData() {
    return this.http.get('./assets/CommonFile/data.json')
  }


  decrypt(encryptString) {
    var CryptoJS = require('crypto-js')
    var base64EncodedKeyFromJava = 'QUJDREVGR0hJSktMTU5PUA==';
    var keyForCryptoJS = CryptoJS.enc.Base64.parse(base64EncodedKeyFromJava);
    var decodeBase64 = CryptoJS.enc.Base64.parse(encryptString)
    var decryptedData = CryptoJS.AES.decrypt(
      {
        ciphertext: decodeBase64
      },
      keyForCryptoJS,
      {
        mode: CryptoJS.mode.ECB
      }
    );
    var decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    console.log(decryptedText);
    return decryptedText;
  }

  makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }


  // async getUserToken(url1, token) {
  //   let url;
  //   let getUrl = url1.includes("?");
  //   if (getUrl) {
  //     const firstUrl = url1.split("?");
  //     url = firstUrl[0];
  //   } else {
  //     url = url1
  //   }
  //   const obj = {
  //     "_user_code": "Emp10108",
  //     "_user_token": "",
  //     "_url": url,
  //     "_succ_msg": ""
  //   }
  //   await this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(obj), { headers: this.getHeaders('/iudUsertoken', token) }).subscribe(async (res: any) => {
  //     if (res) {
  //       const a = await sessionStorage.getItem('iudUserToken');
  //       this.tokenArray = await JSON.parse(a);
  //       if (this.tokenArray.length > 0) {
  //         await this.tokenArray.forEach((element, index) => {
  //           if (element.url == res.myArrayList[0].map._url) {
  //             this.tokenArray.splice(index, 1);
  //           }
  //         });
  //       }
  //       var obj = {
  //         'url': res.myArrayList[0].map._url,
  //         'token': res.myArrayList[0].map._user_token
  //       };
  //       this.tokenArray.push(obj);
  //       await sessionStorage.setItem('iudUserToken', JSON.stringify(this.tokenArray));

  //       await localStorage.setItem('iudUserToken', JSON.stringify(this.tokenArray));

  //     }
  //   })
  // }
}


 /*  encrypt(word){
    //  const ciphertext = CryptoTS.AES.encrypt(word, 'o9szYIOq1rRMiouNhNvaq96lqUvCekxR');
      const ciphertext = CryptoJS.AES.encrypt(word, 'o9szYIOq1rRMiouNhNvaq96lqUvCekxR');
      return ciphertext.toString();
    }*/


  /* encrypt(word){
     // Code goes here
     var keySize = 256;
     var ivSize = 128;
     var iterations = 100;

     const keyBase64 = "o9szYIOq1rRMiouNhNvaq96lqUvCekxR"; 
     var key = CryptoJS.enc.Base64.parse(keyBase64);
     var salt = CryptoJS.lib.WordArray.random(128/8);
 
     var key = CryptoJS.PBKDF2(keyBase64, salt, {
         keySize: keySize/32,
         iterations: iterations
       });
     var iv = CryptoJS.lib.WordArray.random(128/8);

     var encrypted = CryptoJS.AES.encrypt(word, key, { 
       iv: iv, 
       padding: CryptoJS.pad.Pkcs7,
       mode: CryptoJS.mode.CBC
       
     });

     // salt, iv will be hex 32 in length
     // append them to the ciphertext for use  in decryption
     var transitmessage = salt.toString()+ iv.toString() + encrypted.toString();
     
     return transitmessage;
 }*/